package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class MindMapNodeNoteQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-644_640_603, arrayOf("mind_map_node_note"), driver,
      "MindMapNodeNote.sq", "selectAll",
      "SELECT mind_map_node_note.id, mind_map_node_note.node_id, mind_map_node_note.note_id, mind_map_node_note.order_index, mind_map_node_note.created_at, mind_map_node_note.updated_at, mind_map_node_note.is_deleted, mind_map_node_note.deleted_at, mind_map_node_note.synced_at FROM mind_map_node_note WHERE is_deleted = 0 ORDER BY node_id, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectAll(): Query<Mind_map_node_note> = selectAll { id, node_id, note_id, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node_note(
      id,
      node_id,
      note_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectById(id: String): Query<Mind_map_node_note> = selectById(id) { id_, node_id,
      note_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node_note(
      id_,
      node_id,
      note_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByNode(node_id: String, mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByNodeQuery(node_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectByNode(node_id: String): Query<Mind_map_node_note> = selectByNode(node_id) { id,
      node_id_, note_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node_note(
      id,
      node_id_,
      note_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByNodeAnyState(node_id: String, mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByNodeAnyStateQuery(node_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectByNodeAnyState(node_id: String): Query<Mind_map_node_note> =
      selectByNodeAnyState(node_id) { id, node_id_, note_id, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Mind_map_node_note(
      id,
      node_id_,
      note_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByNote(note_id: String, mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByNoteQuery(note_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectByNote(note_id: String): Query<Mind_map_node_note> = selectByNote(note_id) { id,
      node_id, note_id_, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node_note(
      id,
      node_id,
      note_id_,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByMap(map_id: String, mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByMapQuery(map_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectByMap(map_id: String): Query<Mind_map_node_note> = selectByMap(map_id) { id,
      node_id, note_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node_note(
      id,
      node_id,
      note_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_021_638_186, arrayOf("mind_map_node_note"), driver,
      "MindMapNodeNote.sq", "selectDirty",
      "SELECT mind_map_node_note.id, mind_map_node_note.node_id, mind_map_node_note.note_id, mind_map_node_note.order_index, mind_map_node_note.created_at, mind_map_node_note.updated_at, mind_map_node_note.is_deleted, mind_map_node_note.deleted_at, mind_map_node_note.synced_at FROM mind_map_node_note WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectDirty(): Query<Mind_map_node_note> = selectDirty { id, node_id, note_id,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map_node_note(
      id,
      node_id,
      note_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Mind_map_node_note> = selectByIdAnyState(id) {
      id_, node_id, note_id, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Mind_map_node_note(
      id_,
      node_id,
      note_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    node_id: String,
    note_id: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-603_328_231, """
        |INSERT INTO mind_map_node_note(id, node_id, note_id, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?)
        """.trimMargin(), 6) {
          bindString(0, id)
          bindString(1, node_id)
          bindString(2, note_id)
          bindLong(3, order_index)
          bindLong(4, created_at)
          bindLong(5, updated_at)
        }
    notifyQueries(-603_328_231) { emit ->
      emit("mind_map_node_note")
    }
  }

  public fun update(
    node_id: String,
    note_id: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-258_382_039, """
        |UPDATE mind_map_node_note
        |SET node_id = ?, note_id = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 5) {
          bindString(0, node_id)
          bindString(1, note_id)
          bindLong(2, order_index)
          bindLong(3, updated_at)
          bindString(4, id)
        }
    notifyQueries(-258_382_039) { emit ->
      emit("mind_map_node_note")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_743_053_611,
        """UPDATE mind_map_node_note SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_743_053_611) { emit ->
      emit("mind_map_node_note")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_912_041_518,
        """UPDATE mind_map_node_note SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_912_041_518) { emit ->
      emit("mind_map_node_note")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-1_923_115_818, """DELETE FROM mind_map_node_note WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-1_923_115_818) { emit ->
      emit("mind_map_node_note")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-540_159_993,
        """UPDATE mind_map_node_note SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-540_159_993) { emit ->
      emit("mind_map_node_note")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node_note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node_note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_491_019_086,
        """SELECT mind_map_node_note.id, mind_map_node_note.node_id, mind_map_node_note.note_id, mind_map_node_note.order_index, mind_map_node_note.created_at, mind_map_node_note.updated_at, mind_map_node_note.is_deleted, mind_map_node_note.deleted_at, mind_map_node_note.synced_at FROM mind_map_node_note WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "MindMapNodeNote.sq:selectById"
  }

  private inner class SelectByNodeQuery<out T : Any>(
    public val node_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node_note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node_note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_649_572_491,
        """SELECT mind_map_node_note.id, mind_map_node_note.node_id, mind_map_node_note.note_id, mind_map_node_note.order_index, mind_map_node_note.created_at, mind_map_node_note.updated_at, mind_map_node_note.is_deleted, mind_map_node_note.deleted_at, mind_map_node_note.synced_at FROM mind_map_node_note WHERE node_id = ? AND is_deleted = 0 ORDER BY order_index, created_at""",
        mapper, 1) {
      bindString(0, node_id)
    }

    override fun toString(): String = "MindMapNodeNote.sq:selectByNode"
  }

  private inner class SelectByNodeAnyStateQuery<out T : Any>(
    public val node_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node_note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node_note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-537_177_446,
        """SELECT mind_map_node_note.id, mind_map_node_note.node_id, mind_map_node_note.note_id, mind_map_node_note.order_index, mind_map_node_note.created_at, mind_map_node_note.updated_at, mind_map_node_note.is_deleted, mind_map_node_note.deleted_at, mind_map_node_note.synced_at FROM mind_map_node_note WHERE node_id = ?""",
        mapper, 1) {
      bindString(0, node_id)
    }

    override fun toString(): String = "MindMapNodeNote.sq:selectByNodeAnyState"
  }

  private inner class SelectByNoteQuery<out T : Any>(
    public val note_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node_note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node_note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_649_571_995,
        """SELECT mind_map_node_note.id, mind_map_node_note.node_id, mind_map_node_note.note_id, mind_map_node_note.order_index, mind_map_node_note.created_at, mind_map_node_note.updated_at, mind_map_node_note.is_deleted, mind_map_node_note.deleted_at, mind_map_node_note.synced_at FROM mind_map_node_note WHERE note_id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, note_id)
    }

    override fun toString(): String = "MindMapNodeNote.sq:selectByNote"
  }

  private inner class SelectByMapQuery<out T : Any>(
    public val map_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node_note", "mind_map_node", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node_note", "mind_map_node", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_023_044_727, """
    |SELECT l.id, l.node_id, l.note_id, l.order_index, l.created_at, l.updated_at, l.is_deleted, l.deleted_at, l.synced_at FROM mind_map_node_note l
    |JOIN mind_map_node n ON n.id = l.node_id
    |WHERE n.map_id = ? AND l.is_deleted = 0 AND n.is_deleted = 0
    |ORDER BY l.node_id, l.order_index
    """.trimMargin(), mapper, 1) {
      bindString(0, map_id)
    }

    override fun toString(): String = "MindMapNodeNote.sq:selectByMap"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map_node_note", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map_node_note", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(153_094_515,
        """SELECT mind_map_node_note.id, mind_map_node_note.node_id, mind_map_node_note.note_id, mind_map_node_note.order_index, mind_map_node_note.created_at, mind_map_node_note.updated_at, mind_map_node_note.is_deleted, mind_map_node_note.deleted_at, mind_map_node_note.synced_at FROM mind_map_node_note WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "MindMapNodeNote.sq:selectByIdAnyState"
  }
}
